var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRuby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    role: "img",
    "aria-label": "Ruby",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#a00403",
    d: "m407.7,397.3l20.86,-257.7l-80.54,157.4l-196,118c80.86,-5.675 171.2,-11.87 255.7,-17.66l-0.02,-0.04z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#b11205",
    d: "m423.39,178.977l-103.39,-80.977l-27,93c109.797,9.317 91.763,-9.646 130.39,-12.023zm-231.39,103.023l136,43l-35,-134l-101,91zm-89,19c44,139 55,169 89,-19l-90,21l1,-2zm173,-233l97,1l-53,29c-11,-7 -36,-24 -44,-30zm-191,178l-4,99l23,-43l-19,-56zm213,-161c26,26 -1,89 -53,140s-118,83 -144,57c-25,-25.89 0.7,-90 52.85,-141s119.2,-82 144.2,-56l-0.05,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "#9f0d02",
    d: "m192,282l133,43c-48,45 -137.5,86.5 -173,90l40,-133z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    fill: "#891102",
    d: "m293,191l33,133c40,-42 76,-88 94,-144l-127,11zm114.7,206.3l-20.68,-152.3l-61.02,79l81.7,73.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    fill: "#aa1401",
    d: "m421,181c13,-41 16,-101 -48,-112l-53,29l101,83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    fill: "#9e1209",
    d: "m81,345c2,68 50,69 71,70l-49,-113l-22,43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    fill: "#900e04",
    d: "m192,282l54,103c32,-17 57,-38 79,-61l-133,-42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    fill: "#8b1104",
    d: "m103,302l-8,91c14,20 34,21 55,20c-15,-37 -45,-112 -47,-111z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuby);
export default __webpack_public_path__ + "static/media/ruby.1aab892e4cc0a9bf1551fa09b63ea8b0.svg";
export { ForwardRef as ReactComponent };